import { cva, type VariantProps } from 'cva';

export const variants = {};

export const classes = cva({
  base: 'app-search',
  variants,
});

export type AppSearchVariantProps = VariantProps<typeof classes>;
